import { Trans, useTranslation } from "react-i18next";
import { supabaseAvailable } from "../auth/AuthProvider";

export function ConfigBanner() {
  const { t } = useTranslation("auth");
  if (supabaseAvailable) return null;
  return (
    <div className="border-b border-amber-200 bg-amber-50 px-4 py-2 text-center text-xs text-amber-900">
      <Trans t={t} i18nKey="configBanner" />
    </div>
  );
}
